import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import CinematicCanvas from './components/CinematicCanvas';
import AppLayout from './components/layout/AppLayout';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import DashboardPage from './pages/DashboardPage';
import RegulationsPage from './pages/RegulationsPage';
import ConsultationPage from './pages/ConsultationPage';
import LearningPage from './pages/LearningPage';
import AdminUsersPage from './pages/AdminUsersPage';
import AdminRegulationsPage from './pages/AdminRegulationsPage';
import AdminCoursesPage from './pages/AdminCoursesPage';
import SurveyPage from './pages/SurveyPage';
import AdminSurveysPage from './pages/AdminSurveysPage';
import FormLinksPage from './pages/FormLinksPage';
import AdminFormLinksPage from './pages/AdminFormLinksPage';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <CinematicCanvas />
        <BrowserRouter>
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 3000,
              style: {
                fontFamily: 'var(--font-sans)',
                fontSize: '0.875rem',
                background: 'var(--bg-card)',
                color: 'var(--text-primary)',
                border: '1px solid var(--border-primary)',
                boxShadow: 'var(--shadow-lg)'
              }
            }}
          />
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/survey" element={<SurveyPage />} />

            <Route element={<AppLayout pageTitle="Dashboard" pageSubtitle="Ringkasan Informasi" />}>
              <Route path="/dashboard" element={<DashboardPage />} />
            </Route>
            <Route element={<AppLayout pageTitle="Peraturan" pageSubtitle="Database Peraturan Pengadaan" />}>
              <Route path="/peraturan" element={<RegulationsPage />} />
            </Route>
            <Route element={<AppLayout pageTitle="Konsultasi" pageSubtitle="Tanya Ahli Pengadaan" />}>
              <Route path="/konsultasi" element={<ConsultationPage />} />
            </Route>
            <Route element={<AppLayout pageTitle="Pembelajaran" pageSubtitle="Tingkatkan Kompetensi PBJ" />}>
              <Route path="/pembelajaran" element={<LearningPage />} />
            </Route>
            <Route element={<AppLayout pageTitle="Formulir" pageSubtitle="Isi Formulir Tersedia" />}>
              <Route path="/form-links" element={<FormLinksPage />} />
            </Route>

            {/* Admin routes */}
            <Route element={<AppLayout pageTitle="Kelola Pengguna" pageSubtitle="Administrasi" />}>
              <Route path="/admin/users" element={<AdminUsersPage />} />
            </Route>
            <Route element={<AppLayout pageTitle="Survey Kepuasan Masyarakat" pageSubtitle="Respon Ahli" />}>
              <Route path="/admin/surveys" element={<AdminSurveysPage />} />
            </Route>
            <Route element={<AppLayout pageTitle="Kelola Peraturan" pageSubtitle="Administrasi" />}>
              <Route path="/admin/regulations" element={<AdminRegulationsPage />} />
            </Route>
            <Route element={<AppLayout pageTitle="Kelola Kursus" pageSubtitle="Administrasi" />}>
              <Route path="/admin/courses" element={<AdminCoursesPage />} />
            </Route>
            <Route element={<AppLayout pageTitle="Pengaturan Link" pageSubtitle="Kelola Google Form" />}>
              <Route path="/admin/form-links" element={<AdminFormLinksPage />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
